import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'

import { AssetsContext } from '../../context'
import { ApplicationContext } from '@contexts/ApplicationContext'
import { ActionablesContext } from '@contexts/ActionablesContext'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { CurrentAssetsCards } from './Cards'
import { CurrentAssetsTable } from './Table'
import { ListIcon } from '@components/Icons/ListIcon'
import { GridIcon } from '@components/Icons/GridIcon'
import Http from '@shared/http'
import { Button } from '@components/Button'
import { CardFooter } from '@components/layout/Card'

// The table view is at index 0,
// i.e. first tab panel in code
const TABLE_VIEW_TAB = 0

export const AssetTabs = () => {
  const { state, actions } = useContext(AssetsContext)
  const { assetView, tenant } = state
  const { setAssetView } = actions
  const { user: { client_id } } = useContext(ApplicationContext)

  const selectedTab = assetView === 'list' ? 0 : 1

  const handleAssetViewToggle = (view, tenant, client_id) => {
    setAssetView(view)
    assetViewToggle(view, tenant, client_id)
  }

  return (
    <>
      <Tabs
        component='section'
        defaultIndex={selectedTab}
        className='app-tabs'
      >
        <TabList className='app-tabs__list flex justify-end'>
          <Tab onClick={() => handleAssetViewToggle('list', tenant, client_id)} className='app-tabs__list-item app-tabs__list-item--borderless'
            selectedClassName='app-tabs__list-item--selected'><ListIcon /></Tab>
          <Tab onClick={() => handleAssetViewToggle('grid', tenant, client_id)} className='app-tabs__list-item app-tabs__list-item--borderless'
            selectedClassName='app-tabs__list-item--selected'><GridIcon /></Tab>
        </TabList>

        <TabPanel >
          <CurrentAssetsTable />
        </TabPanel>
        <TabPanel >
          <CurrentAssetsCards />
        </TabPanel>
      </Tabs>
      {selectedTab === TABLE_VIEW_TAB &&
        <CardFooter>
          <TableViewButtons />
        </CardFooter>
      }
    </>
  )
}

const assetViewToggle = (state, client_id) => {
  Http.request(`/clients/${client_id}/toggle_assets_view/${state}`, 'PUT')
}

const TableViewButtons = () => {
  const { readOnly, frozen } = useContext(ActionablesContext)
  const {
    state: { onCreateNewScenario },
    actions: { goToAddAsset }
  } = useContext(AssetsContext)
  const classes = 'flex gap-2 ml:gap-4'

  if (frozen) return null

  if (readOnly) {
    return (
      <Box
        className={classes}
      >
        <p>You can add assets in scenario planning</p>
        <Button primary onClick={() => onCreateNewScenario()} trackAs="Asset Table: New scenario">Create a new scenario</Button>
      </Box>
    )
  }

  return (
    <Box className={classes}>
      <Button primary onClick={goToAddAsset} trackAs="Add asset table: Add asset">Add asset</Button>
    </Box>
  )
}
